import React, { useState } from 'react';
import AdminModal from './admins/AdminModal';
import Loading from './Loading';
import { useConfirm } from './ConfirmContext';
import Table from './Table';
import Widget from './admins/Widget';

import { ReactComponent as PlusIcon } from './images/plus.svg';

const Admins = ({admins, setAdmins}) => {
  const confirm = useConfirm();
  let [editedAdmin, setEditedAdmin] = useState(null);
  let [modalVisible, setModalVisible] = useState(false);

  const saveAdmin = (index, newAdmin) => {
    let newAdmins;
    let id = null;

    if (index !== undefined) {
      id = admins[index].id;
      newAdmins = admins.map((admin, i) => {
        if (i === index) {
          let u = admin;
          u.name = newAdmin.name;
          u.email = newAdmin.email;
          if (newAdmin.password !== '') {
            u.password = newAdmin.password;
            u.resetPassword = true;
          }
          return u;
        }
        return admin;
      });
    }
    else {
      newAdmins = [...admins, {...newAdmin,
                               resetPassword: true,
                               index: admins.length}];
      index = admins.length;
    }

    setAdmins(newAdmins);

    fetch(process.env.REACT_APP_SERVER_URL + '/api/set-admin', {
      method: 'POST',
      headers: {
        'Authorization': localStorage.getItem('token'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        admin: newAdmins[index],
        id,
      }),
    })
      .catch(error => console.log(error));
  }

  const deleteAdmin = async (index) => {
    const confirmed = await confirm(`Are you sure you want to delete administrator ${admins[index].name}?`);
    if (confirmed) {
      let id = admins[index].id;
      setAdmins(admins.filter((admin, i) => i !== index))
      fetch(process.env.REACT_APP_SERVER_URL + '/api/delete-admin', {
        method: 'POST',
        headers: {
          'Authorization': localStorage.getItem('token'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id }),
      })
        .catch(error => console.log(error));
    }
  }

  if (admins === null) return <Loading />;

  const computeContents = (admins) => {
    return admins.map(admin => {
      return [admin.name,
              admin.email,
              <Widget editAdmin={() => {
                        setEditedAdmin(admin);
                        setModalVisible(true);
                      }}
                      deleteAdmin={() => deleteAdmin(admin.index)} />
             ];
    });
  }

  return (
    <div style={{width: 'calc(100% - 40px)',
                 overflowY: 'auto',
                 padding: '20px',
                 display: 'flex',
                 flexDirection: 'column',
                 gap: '20px',
                }}>
      {modalVisible && <AdminModal setVisible={setModalVisible}
                                   saveAdmin={saveAdmin}
                                   admin={editedAdmin}
                       />}

      <div style={{display: 'flex',
                   width: '100%',
                   flexDirection: 'row-reverse',
                  }}>
        <PlusIcon className='image'
                  style={{width: '20px',
                          height: '20px',
                          fill: 'white',
                          cursor: 'pointer',
                         }}
                  onClick={() => {
                    setEditedAdmin(null);
                    setModalVisible(true)
                  }} />
      </div>

      <Table headers={['Name', 'Email', '']}
             contents={computeContents(admins)}
             proportions={[1, 2, 1]} />
    </div>
  );
}

export default Admins;
